"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BlockSpacerEditorTop = exports.BlockSpacer = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _immer = _interopRequireDefault(require("immer"));

var __jsx = _react["default"].createElement;

var BlockSpacer = function BlockSpacer(_ref) {
  var block = _ref.block;
  return __jsx(_react["default"].Fragment, null, __jsx(_react2.Box, {
    height: block.content.height,
    transition: "height .25s ease",
    background: "repeating-linear-gradient( 45deg, rgba(255, 255, 255, .15) 0px, rgba(255, 255, 255, .15) 10px, rgba(0, 0, 0, .1) 10px, rgba(0, 0, 0, .1) 20px )"
  }));
};

exports.BlockSpacer = BlockSpacer;

var BlockSpacerEditorTop = function BlockSpacerEditorTop(props) {
  var onInputHeightChange = function onInputHeightChange(value) {
    value = Math.max(10, value);
    value = Math.min(500, value);
    props.onUpdate((0, _immer["default"])(props.block, function (draft) {
      draft.content.height = "".concat(value, "px");
    }));
  };

  return __jsx(_react["default"].Fragment, null, __jsx(_react2.Box, null, __jsx(_react2.NumberInput, {
    onChange: onInputHeightChange,
    defaultValue: props.block.content.height,
    min: 10,
    max: 500
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null)))));
}; //


exports.BlockSpacerEditorTop = BlockSpacerEditorTop;